import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from "./assets/locales/translationEN.json";
import translationSV from "./assets/locales/translationSV.json";
import translationBG from "./assets/locales/translationBG.json";
import translationPT from "./assets/locales/translationPT.json";
import translationES from "./assets/locales/translationES.json";
import translationSQ from "./assets/locales/translationSQ.json";

import { isDate, format as formatDate } from 'date-fns';
import { enGB, bg, sv, es, pt, sq} from "date-fns/locale";

const locales = { enGB, bg, sv, es, pt, sq };

const layout = JSON.parse(window.localStorage.getItem('layout') || 'null')
const language = window.localStorage.getItem('language')

const resources = {
  en: {
    translation: translationEN
  },
  sv: {
    translation: translationSV
  },
  bg: {
    translation: translationBG
  },
  pt: {
    translation: translationPT
  },
  es: {
    translation: translationES
  },
  sq: {
    translation: translationSQ
  }
};

i18n
  .use(initReactI18next)
  .init({
    lng: language ? language : 'en',
    resources,
    debug: true,
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
				if (isDate(value)) {
					const locale = (lng == 'en' ? enGB : locales[lng]);

					if (format === "short")
						return formatDate(value, "P", { locale });
					if (format === "long"){
            return formatDate(value, "PPPP", { locale });
          }

					return formatDate(value, format, { locale });
				}
      },
    }
  })

export default i18n
